/* eslint-disable import/prefer-default-export */
import * as yup from "yup";
import { status } from "./phoneEmailStatus";

export const phone = yup
  .string()
  .matches(/^\+1\d{10}$/, {
    excludeEmptyString: true,
    message: "Must be a valid 10-digit US phone number.",
  })
  .label("Phone Number")
  .nullable();

export function coercePhoneTransform(value: unknown) {
  if (!value) return value;

  const strValue = typeof value === "number" ? String(value) : value;

  if (typeof strValue !== "string") {
    throw new yup.ValidationError(
      "Received an invalid data type for a phone number",
      value,
    );
  }

  return `+1${strValue.replace(/(^\+1|\D)/g, "")}`;
}

export { status };
